import { useState } from "react";
import { progress } from "@/mocks/comicData";

const volumes = [
  { vol: "第10卷", name: "青云万药谷", chapters: "第301-320话" },
  { vol: "第11卷", name: "医仙大会", chapters: "第321-328话" },
  { vol: "第12卷", name: "济世归来 · 连载中", chapters: "第329话起", active: true },
];

export default function SerialProgress() {
  const [readPct, setReadPct] = useState(progress.readPercent);

  const reset = () => {
    setReadPct(0);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section id="progress" className="w-full bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-800">
              <i className="ri-timer-line"></i>连载进度
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              连载进度 · 追到哪里一目了然
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              《天才医仙》已连载至第 {progress.totalChapters} 话，共 {progress.totalVolumes}{" "}
              卷。下方可查看你的阅读进度，收藏本站后进度自动保存，随时接着看。
            </p>

            <div className="mt-7 rounded-lg border border-background-200 bg-background-50 p-6">
              <div className="flex items-center justify-between text-sm">
                <span className="text-foreground-700">你的阅读进度</span>
                <span className="font-heading font-bold text-primary-700">{readPct}%</span>
              </div>
              <div className="mt-3 h-2.5 w-full overflow-hidden rounded-full bg-background-200">
                <div
                  className="h-full rounded-full bg-gradient-to-r from-primary-500 to-primary-700 transition-all duration-500"
                  style={{ width: `${readPct}%` }}
                ></div>
              </div>
              <p className="mt-3 text-xs text-foreground-600">
                已读完约 {Math.round((progress.finished * readPct) / 100)} 话 / 共 {progress.totalChapters} 话
              </p>
              <button
                type="button"
                onClick={reset}
                className="mt-5 whitespace-nowrap rounded-md border border-background-200 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-refresh-line mr-1.5"></i>重置阅读记录
              </button>
            </div>

            <div className="mt-5 grid grid-cols-3 gap-3">
              {[
                { label: "周更次数", value: "每周3更" },
                { label: "更新日", value: "二·四·六" },
                { label: "平均时长", value: "约15分钟" },
              ].map((s) => (
                <div key={s.label} className="rounded-lg border border-background-200 bg-background-50 p-4 text-center">
                  <p className="text-xs text-foreground-600">{s.label}</p>
                  <p className="mt-1 font-heading text-sm font-bold text-foreground-950">{s.value}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">卷数进度时间线</h3>
            <ol className="relative mt-6 space-y-5 border-l border-background-200 pl-6">
              {volumes.map((v) => (
                <li key={v.vol} className="relative">
                  <span
                    className={`absolute -left-[31px] flex h-5 w-5 items-center justify-center rounded-full ring-4 ring-background-100 ${
                      v.active ? "bg-accent-500" : "bg-primary-500"
                    }`}
                  >
                    {v.active && <i className="ri-play-fill text-[10px] text-background-50"></i>}
                  </span>
                  <div className="rounded-lg border border-background-200 bg-background-50 p-4">
                    <div className="flex items-center justify-between">
                      <span className="font-heading font-bold text-foreground-950">{v.vol}</span>
                      {v.active && (
                        <span className="whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-700">
                          连载中
                        </span>
                      )}
                    </div>
                    <p className="mt-1 text-sm text-foreground-700">{v.name}</p>
                    <p className="mt-0.5 text-xs text-foreground-600">{v.chapters}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}